import styles from './style.form.css'
import {Field, reduxForm} from 'redux-form'
import AuthField from 'components/Fields/AuthField'

const validate = values => {
  const errors = {}
  let { email, password } = values
  if (!email) {
    errors.email = 'The email address is required'
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email.trim())) {
    errors.email = 'The value is not a valid email address'
  }
  if (!password) {
    errors.password = 'The password is required'
  } else if (password.length < 6) {
    errors.password = 'Password at least have to be 6 characters long'
  }
  return errors
}

class LoginForm extends React.Component {
  render () {
    let {handleSubmit, currentlySending} = this.props
    let statusButton = currentlySending ? 'active' : ''

    return (
      <div>
        <form onSubmit={handleSubmit} className={styles['login-form']}>
          <Field
            component={AuthField}
            name='email'
            type='text'
            placeholder='Email'
            autoCorrect='off'
            maxLength='40'
            autoCapitalize='off'
            icon='fa fa-envelope-o'
            spellCheck='false'
          />
          <Field
            component={AuthField}
            icon='fa fa-lock'
            name='password'
            maxLength='40'
            type='password'
            placeholder='Password'
          />
          <div className={styles['submit-btn']}>
            <button
              className={`btn btn-primary btn-block has-spinner ${statusButton}`}
              disabled={currentlySending}>
              {this.props.btnText}
            </button>
          </div>
        </form>
      </div>
    )
  }
}

LoginForm.propTypes = {
  dispatch: React.PropTypes.func,
  data: React.PropTypes.object,
  onSubmit: React.PropTypes.func,
  changeForm: React.PropTypes.func,
  btnText: React.PropTypes.string,
  currentlySending: React.PropTypes.bool
}

const mapFormValidation = {
  form: 'loginForm',
  touchOnBlur: false,
  touchOnChange: true,
  validate
}

export default reduxForm(mapFormValidation)(LoginForm)



// WEBPACK FOOTER //
// ./app/pages/Login/LoginForm.js